import React, { useEffect, Fragment, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Router, Route, Routes, useNavigate } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import InitializePrincipal from "./pages/principal/Initialize";
import Timetable from "./pages/principal/Timetable";
import AddManagerPrincipal from "./pages/principal/AddManager";
import FeedbackForm from "./pages/FeedbackForm";
import Classes from "./pages/Classes";
import Meetings from "./pages/Meetings";
import ErrorReport from "./pages/ErrorReport";
import Notifications from "./pages/Notifications";
import Expired from "./pages/Expired";
import Oops from "./pages/Oops";
import Loader from "./pages/Loader";
import Messenger from "./pages/Messenger";
import Exams from "./pages/Exams";
import Ranking from "./pages/Ranking";
import Results from "./pages/Results";
import Settings from "./pages/Settings";
import Feedback from "./pages/Feedback";
import Attendance from "./pages/Attendance";
import Support from "./pages/Support";
import Forgot from "./pages/Forgot";
import Logout from "./pages/Logout";
import Events from "./pages/Events";
import Login from "./pages/Login";
import LeaveRequests from "./pages/LeaveRequests";
import Shuffle from "./pages/onboarding/Shuffle";
import Students from "./pages/Students";
import Teachers from "./pages/Teachers";
import StudentsBilling from "./pages/billing/StudentsBilling";
import AddFees from "./pages/billing/AddFees";
import FeeStructure from "./pages/billing/FeeStructure";
import Transactions from "./pages/billing/Transactions";
import Staff from "./pages/Staff";
import AllRoutes from "./pages/transport/AllRoutes";
import Drivers from "./pages/transport/Drivers";
import Journeys from "./pages/transport/Journeys";
import StudentSelection from "./pages/StudentSelection";
import StudentProfile from "./pages/StudentProfile";
import FeesParent from "./pages/parent/FeesParent";
import Registrations from "./pages/Registrations";
import Register from "./pages/Register";

import { loadUser, TEST } from "./actions/auth";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

function App() {
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  // console.log('App S state: ' + JSON.stringify(state))

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  function handleWindowSizeChange() {
    if (window.innerWidth <= 1300) {
      dispatch({ type: "MOBILE_VIEW", payload: true });
    } else {
      dispatch({ type: "MOBILE_VIEW", payload: false });
    }
  }

  useEffect(() => {
    if (window.location.pathname !== "/register-admission") {
      dispatch({ type: "USER_LOADING" });
      dispatch(loadUser());
    }
  }, []);

  if (state.auth.loginFailed) {
    if (
      window.location.pathname !== "/initialize" ||
      window.location.pathname === "/addmanager"
    ) {
      navigate("/login", { replace: true });
      dispatch({ type: "RESET_REDIRECT_LOGIN" });
    }
  }
  if (window.location.pathname == "/register-admission") {
    return <Register />;
  }
  return (
    <Routes>
      <Route exact path="/" element={<Loader />} />
      <Route path="/login" element={<Login />} />
      <Route path="/timetable" element={<Timetable />} />
      <Route path="/initialize" element={<InitializePrincipal />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/forgotpassword" element={<Forgot />} />
      <Route path="/classes" element={<Classes />} />
      <Route path="/shuffle" element={<Shuffle />} />
      <Route path="/students" element={<Students />} />
      <Route path="/fee-collection" element={<StudentsBilling />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/fees-parent" element={<FeesParent />} />
      <Route path="/add-fees" element={<AddFees />} />
      <Route path="/fee-structure" element={<FeeStructure />} />
      <Route path="/inventory" element={<Inventory />} />
      <Route path="/student_selection" element={<StudentSelection />} />
      <Route path="/student_profile" element={<StudentProfile />} />
      <Route path="/teachers" element={<Teachers />} />
      <Route path="/staff" element={<Staff />} />
      <Route path="/all_routes" element={<AllRoutes />} />
      <Route path="/journeys" element={<Journeys />} />
      <Route path="/drivers" element={<Drivers />} />
      <Route path="/messenger" element={<Messenger />} />
      <Route path="/exams" element={<Exams />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/results" element={<Results />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/register-admission" element={<Register />} />
      <Route path="/attendance" element={<Attendance />} />
      <Route path="/leave_requests" element={<LeaveRequests />} />
      <Route path="/meetings" element={<Meetings />} />
      <Route path="/support" element={<Support />} />
      <Route path="/events" element={<Events />} />
      <Route path="/registrations" element={<Registrations />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/addmanager" element={<AddManagerPrincipal />} />
      <Route path="/expired" element={<Expired />} />
      <Route path="/error-report" element={<ErrorReport />} />
      <Route path="/feedback-form" element={<FeedbackForm />} />
      <Route path="*" element={<Oops />} />
    </Routes>
  );
}

export default App;
